import * as React from "react";
import sample from "../../../../public/sample.csv";

interface OwnProps {
  uploadPatients: (file: FormData) => void;
  uploadRowErrors: { [k: string]: string } | null;
}

interface OwnState {
  submitDisabled: boolean;
  file: FormData | null;
}

type Props = OwnProps;

class UploadPatients extends React.PureComponent<Props, OwnState> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected dropdownMenu: any;
  constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true,
      file: null
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFileChangeHandler = (event: any) => {
    const formData = new FormData();
    formData.append("file", event.target.files[0]);

    this.setState({
      file: formData
    });

    this.props.uploadPatients(formData);
  };

  render() {
    return (
      <div className="uploadContainer right">
        <div
          className="menu"
          ref={element => {
            this.dropdownMenu = element;
          }}
        >
          {this.props.uploadRowErrors && (
            <div className="uploadErrors">
              <div className="red">
                Please correct the following problem(s) found in your patient census file
              </div>
              <div className="flex">
                <div className="flex-1 header">Row #</div>
                <div className="flex-3 header">Field Errors</div>
              </div>
              {Object.values(this.props.uploadRowErrors)
                .filter(row => Object.keys(row).length)
                .map((row, rowIndex) => (
                  <div key={rowIndex} className="flex">
                    <div className="flex-1">{rowIndex + 1}</div>
                    <div className="flex-3">
                      <ul>
                        {Object.keys(row).map(fieldName => (
                          <li key={fieldName}>
                            {fieldName}: {row[fieldName]}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
            </div>
          )}
          <div>
            <div className="bold">You can upload a file to import many patients.</div>
            <div className="mt-10 mb-20">
              Please use the sample file below to create your upload file.
            </div>
            <div className="mt-10 mb-20">
              <a href={sample} className="hyperlink" download="sample.csv">
                Download a sample file
              </a>
            </div>
            <input type="file" name="file" onChange={this.onFileChangeHandler} />
          </div>
        </div>
      </div>
    );
  }
}

export default UploadPatients;
